module.exports = __webpack_public_path__ + "static/media/helping-others@3x.6cbf4707.png";